import { READ_ACTION, BI_REPORTS_MENU, BI_REPORTS_PN_MENU } from '@/constants/resources'

export default [
  {
    path: '/bi-reports',
    name: 'bi-report-list',
    component: () => import('@/modules/bi_reports/views/BiReportList.vue'),
    meta: {
      resource: BI_REPORTS_MENU,
      additionalResource: BI_REPORTS_PN_MENU,
      action: READ_ACTION,
      pageTitle: 'Relatórios BI',
    },
  },
  {
    path: '/bi-reports/:key',
    name: 'bi-report-view',
    component: () => import('@/modules/bi_reports/views/BiReportView.vue'),
    meta: {
      resource: BI_REPORTS_MENU,
      additionalResource: BI_REPORTS_PN_MENU,
      action: READ_ACTION,
      pageTitle: 'Relatório BI',
    },
  },
]
